export default __webpack_public_path__ + "static/media/recruit-acc3.cb20c0c0.svg";